var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"63a49c93e4890028d4c14fa354b7d9b9f769b1ac"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["reformationbiblecollege-org@ligonier"]={id:"63a49c93e4890028d4c14fa354b7d9b9f769b1ac"};
      